import type { HttpClient } from '../../../types/api';
import type { PostTermConsentParams, PostTermConsentResponse } from '../types';

/**
 * 同意した規約版の同意ログを記録する。冪等（API 側で UNIQUE + upsert）。
 * 拒否は記録しない（GA イベントのみ）ため、拒否時に本関数を呼んではいけない。
 */
export const postTermConsent = async (
  params: PostTermConsentParams,
  httpClient: HttpClient,
): Promise<PostTermConsentResponse> => {
  return await httpClient.post<PostTermConsentResponse>('/user/v1/term-consent', {
    body: JSON.stringify({ oem_term_ids: params.oemTermIds }),
  });
};
